import { render, staticRenderFns } from "./CreateInventory.vue?vue&type=template&id=fca02fc0&scoped=true"
import script from "./CreateInventory.vue?vue&type=script&lang=js"
export * from "./CreateInventory.vue?vue&type=script&lang=js"
import style0 from "./CreateInventory.vue?vue&type=style&index=0&id=fca02fc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca02fc0",
  null
  
)

export default component.exports